import { ref, watch, computed } from 'vue';
import { useFileTreeStore } from '~/stores/file-tree';

export const useFileTree = () => {
  const fileTreeStore = useFileTreeStore();
  const fileTree = ref(fileTreeStore.treeStructure);

  watch(
    () => fileTreeStore.treeStructure,
    (newVal) => {
      fileTree.value = JSON.parse(JSON.stringify(newVal));
    },
    { deep: true }
  );

  return {
    fileTree,
  };
};
export function useMySpaceFolderID() {
  const fileTreeStore = useFileTreeStore();

  const mySpaceFolderID = computed(() => {
    const data = fileTreeStore.commonStructure;
    if (!data) return null;

    const items = Array.isArray(data) ? data : Object.values(data);
    return items.find((item) => item.parent_id === null)?.id || null;
  });

  return { mySpaceFolderID };
}
